var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Faq1',{attrs:{"id":"faq","title":"Frequently Asked Questions","subtitle":"Some answers that may save you an email!","faq":_vm.faq}})}
var staticRenderFns = []

export { render, staticRenderFns }